import React, {useEffect, useState} from 'react';
import { useAuth } from 'react-oidc-context';
import { useLocation, Outlet } from 'react-router-dom'
import { NavLink } from 'react-router-dom';
import { getUser } from '../../auth';
import { Image, Container, Nav, Navbar, Offcanvas, Form } from 'react-bootstrap';
import { UserDropdownComponent } from './UserDropdownComponent';
import { List } from 'react-bootstrap-icons';

export const NavigationBar = () => {
  const auth = useAuth();

  useEffect(() => {
    const handleStorageChange = () => {
      if(getUser() === null){
        window.location.href = '/logged_out';
      }
    }
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    }

  }, [])


  return <Navbar key={'md'} expand='md' className="custom-navbar container-fluid">
    <Container fluid>
      <Navbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler">
        <List className='large-icon' color='white'/>
      </Navbar.Toggle>
      <Navbar.Brand href="/" className="me-auto navbar_brand_text">
        <span className="d-none d-md-inline">
          <Image src={`/CS_MIL_Desc.png?v=${Date.now()}`} alt="GS" height={30} className='me-2 navbar_brand_text'/>
          Milliman Gridstep
        </span>
      </Navbar.Brand>
      <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-md`}
          aria-labelledby={`offcanvasNavbarLabel-expand-md`}
          placement="start"
          className="navbar-offcanvas"
        >
          <Offcanvas.Header closeButton>
              <Offcanvas.Title id={`offcanvasNavbarLabel-expand-md`} className="navbar_brand_text">
                Milliman Gridstep
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="justify-content-start flex-grow-1 pe-3">
                  <Nav.Link as={NavLink}  to="/jobs" className="navbar_text">Jobs</Nav.Link>
                  {/* <Nav.Link as={NavLink} to="/files" className='navbar_text'>Files</Nav.Link> */}
                  <Nav.Link as={NavLink} to="/about" className='navbar_text'>About</Nav.Link>
              </Nav>
            </Offcanvas.Body>
      </Navbar.Offcanvas>
      <Nav className="ms-auto" data-bs-theme="dark" >
        <Nav.Link className="navbar_text">
          <UserDropdownComponent />
        </Nav.Link>
      </Nav> 
    </Container>
  </Navbar>
}